module.exports = __webpack_public_path__ + "img/right1.1c56b67f.png";